<template>
<div class="chapter">
<div class="inner_page">
<div class="imagefp"><img alt="Sand Dollar Summer, by Kimberly K. Jones." class="imagefp" src="images/9781481426534_cover.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?e5611716